import {
	GetSmartMenuPaymentStatusRequest,
	GetSmartMenuPaymentStatusResponse,
	SmartMenuPaymentStatusDTO,
	SuspendDeliveryCommsRequest,
	SuspendDeliveryCommsResponse,
	ResumeDeliveryCommsRequest,
	ResumeDeliveryCommsResponse,
	SuspendTakeAwayCommsRequest,
	SuspendTakeAwayCommsResponse,
	ResumeTakeAwayCommsRequest,
	ResumeTakeAwayCommsResponse,
	SuspendOrResumeTableOrderRequest,
	TableOrderSaleCenterStatusDTO,
	SuspendOrResumeTableOrderResponse,
	StartPublishDigitalMenusRequest,
	GetSmartMenuPublishStatusRequest,
	GetSmartMenuPublishStatusResponse,
	SmartMenuPublishStatusDTO
} from 'core/api';

import { Bus } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');


export async function getPaymentStatus() {
	const request = new GetSmartMenuPaymentStatusRequest();
	return process(request, (response: GetSmartMenuPaymentStatusResponse) => response.Status);
}

export function suspendDeliveryComms(): Promise<SmartMenuPaymentStatusDTO> {
	const request = new SuspendDeliveryCommsRequest();
	return process(request, (response: SuspendDeliveryCommsResponse) => response.Status);
}

export function resumeDeliveryComms(): Promise<SmartMenuPaymentStatusDTO> {
	const request = new ResumeDeliveryCommsRequest();
	return process(request, (response: ResumeDeliveryCommsResponse) => response.Status);
}

export function suspendTakeAwayComms(): Promise<SmartMenuPaymentStatusDTO> {
	const request = new SuspendTakeAwayCommsRequest();
	return process(request, (response: SuspendTakeAwayCommsResponse) => response.Status);
}

export function resumeTakeAwayComms(): Promise<SmartMenuPaymentStatusDTO> {
	const request = new ResumeTakeAwayCommsRequest();
	return process(request, (response: ResumeTakeAwayCommsResponse) => response.Status);
}

export function startPublish(): Promise<StartPublishDigitalMenusRequest> {
	const request = new StartPublishDigitalMenusRequest();
	return process(request);
}

export function getPublishStatus(): Promise<SmartMenuPublishStatusDTO> {
	const request = new GetSmartMenuPublishStatusRequest();
	return process(request, (response: GetSmartMenuPublishStatusResponse) => response.PublishStatus);
}

export function suspendOrResumeTableOrder(statuses: TableOrderSaleCenterStatusDTO[]): Promise<SmartMenuPaymentStatusDTO> {
	const request = new SuspendOrResumeTableOrderRequest({ statuses });
	return process(request, (response: SuspendOrResumeTableOrderResponse) => response.Status);
}
